import { useState, useEffect } from "react";
import axios from "axios";

export default function LogPanel({ API }) {
  const [events, setEvents] = useState([]);

  const fetchEvents = async () => {
    try {
      const res = await axios.get(`${API}/events`);
      setEvents(res.data);
    } catch (err) {
      console.error("Events fetch failed:", err);
    }
  };

  useEffect(() => {
    fetchEvents();
    const interval = setInterval(fetchEvents, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={card}>
      <h2 style={heading}>System Log</h2>
      <div style={logWrap}>
        {!events.length ? (
          <p style={empty}>No events recorded yet</p>
        ) : (
          [...events].reverse().map(e => (
            <div key={e.id} style={logRow}>
              <span style={time}>
                {new Date(e.occurred_at).toLocaleTimeString()}
              </span>
              <span style={{
                ...eventType,
                color: e.event_type.includes("REJECT") || e.event_type.includes("KILL")
                  ? "#e24b4a"
                  : e.event_type.includes("OPEN") || e.event_type.includes("APPROV")
                  ? "#1D9E75"
                  : "#BA7517"
              }}>
                {e.event_type}
              </span>
              <span style={details}>{e.details}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const card = {
  background: "#1a1a1a",
  borderRadius: "12px",
  padding: "20px",
  border: "1px solid #2a2a2a",
  gridColumn: "1 / -1"
};
const heading = {
  margin: "0 0 16px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#ffffff",
  textTransform: "uppercase",
  letterSpacing: "0.5px"
};
const logWrap = {
  maxHeight: "200px",
  overflowY: "auto",
  fontSize: "12px"
};
const logRow = {
  display: "grid",
  gridTemplateColumns: "80px 160px 1fr",
  gap: "12px",
  padding: "6px 0",
  borderBottom: "1px solid #1f1f1f",
  alignItems: "center"
};
const time = { color: "#555" };
const eventType = { fontWeight: "600" };
const details = { color: "#888" };
const empty = {
  color: "#555",
  fontSize: "13px",
  textAlign: "center",
  padding: "20px 0"
};